export const HEAD_LABELS = [
  {
    id: 'id',
    label: 'ID',
    align: 'center',
  },
  {
    id: 'status',
    label: 'Trạng thái',
    align: 'center',
  },
  {
    id: 'resource',
    label: 'Resource',
    align: 'center',
  },
  {
    id: 'file',
    label: 'Tên file',
    align: 'center',
  },
  {
    id: '',
    lable: '',
  },
];
